import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { ScrollableItemsHelperOsService } from '../services/scrollable-items-helper-os.service';
import { ArraySectionDirectiveModel } from '../models/extended-section-options';

@Directive({
	selector: '[cvJsfDisposableSection]'
})
export class DisposableSectionDirective implements OnInit {
	@Input() data: ArraySectionDirectiveModel;

	constructor(
		private scrollableHelper: ScrollableItemsHelperOsService,
		private elementRef: ElementRef
	) {}

	/**
	 * Create a Disposable Element and Validate the Component Exists
	 */
	ngOnInit(): void {
		if (this.data.section && !this.data.skipDirective) {
			const component = (this.data.component)? this.data.component: null;

			this.scrollableHelper.addDisposableItem(
				this.data.section,
				{
					id: this.data.cssClass,
					element: this.elementRef,
					visible: this.data.visible,
					rendered: false,
					section: this.data.section,
					component: component
				}
			);
		}
	}
}
